import styled from '@emotion/styled';

export const ConferenceContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	max-width: 92.2rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;

export const ConferenceHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	width: 100%;
	.share_icon {
		display: flex;
		justify-content: flex-end;
	}
`;
export const ConferenceTitlebox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding-bottom: 1.6rem;
	border-bottom: 1px solid #adb5bd;
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;

export const ConferenceSubTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #868e96;
	white-space: nowrap;
`;

export const ImgBox = styled.div`
	width: 2.4rem;
	height: 2.4rem;
	cursor: pointer;
	img {
		width: 100%;
		height: 100%;
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const Content = styled.div`
	padding-bottom: 2.4rem;
	border-bottom: 1px solid #adb5bd;
	width: 100%;
	line-height: 160%;
	img {
		max-width: 100%;
		height: auto;
		display: block;
	}
`;

export const MenuBox = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const MenuList = styled.div`
	display: flex;
	gap: 0.8rem;
	height: 4.4rem;
`;

export const Menu = styled.button`
	display: flex;
	align-items: center;
	gap: 0.2rem;
	height: 100%;
	padding: 0rem 1.2rem;
	border: 1px solid #212529;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: #fff;
	cursor: pointer;
`;

export const MenuActive = styled(Menu)`
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	border: none;
	color: #fff;
`;

export const DownLoadBox = styled.div`
	display: flex;
	gap: 1.2rem;
	align-items: center;
	padding: 1.2rem;
	background-color: #fff;
	border: 1px solid #dee2e6;
	width: fit-content;
	cursor: pointer;
`;

export const DownLoadContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	max-width: 13.6rem;
	width: 100%;

	.title {
		font-size: 1.4rem;
		font-weight: 400;
		line-height: 100%;
		letter-spacing: -0.6px;
		color: #212529;

		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.sub_title {
		font-size: 1.2rem;
		font-weight: 400;
		line-height: 120%;
		letter-spacing: -0.6px;
		color: #868e96;
	}
`;
export const DownLoadBoxList = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(15rem, 19.2rem));
	gap: 0.8rem;
`;
